import playCardSummarySlice from './playcardsSummary-slice';

export const { setPlayCards, resetState, setPlayCardsSalesSummary, setPlaycardFormDirty, setPlayCardSalesSummary } =
  playCardSummarySlice.actions;

export default playCardSummarySlice;
